export enum RefereeType {
  REFEREE = 1,
  ASSISTANT_REFEREE = 2,
  VAR_REFEREE = 6,
}
